export const UPLOAD_WORKFLOW_FILE_FIELD_TIMEOUT_IN_MS = 30 * (60 * 1000);
